/* js/components/MapLibre.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	binding_callbacks,
	check_outros,
	create_slot,
	detach,
	element,
	get_all_dirty_from_scope,
	get_slot_changes,
	group_outros,
	init,
	insert,
	safe_not_equal,
	transition_in,
	transition_out,
	update_slot_base
} from "svelte/internal";

import { onMount, onDestroy, setContext } from 'svelte';
import { adaptEsriMapStyle, getMapStyle } from '../esriStyleAdapter.js';
import maplibregl from 'maplibre-gl';
import { key } from '../maplibre.js';

// import { fakeGeoLocationProvider } from '../FakeGeoLocationEngine.js';
import { mapEventProvider } from '../mapEventProvider.js';

import { flyToProvider } from '../providers.js';
import { genevaCoords } from '../geoUtils';

function create_if_block(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[9].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[8], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[8], dirty, null),
						null
					);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current;
	let if_block = /*map*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			attr(div, "class", "map svelte-13xk57o");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			/*div_binding*/ ctx[10](div);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*map*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*map*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div, null);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			/*div_binding*/ ctx[10](null);
		}
	};
}

function hackIosRotationSnaffu() {
	
} // console.log("hack ios rotation snaffu");
// document.documentElement.style.height = `initial`;

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { onLoad } = $$props;
	let { startCoordinates } = $$props;
	let { startZoom = 12 } = $$props;
	let { interactive = true } = $$props;
	let { pitch = 50 } = $$props;
	let { useControls = false } = $$props;
	let map;
	let container;
	setContext(key, { getMap: () => map });

	function onFlyToRequest(request) {
		// console.log("flying to ", request);
		if (request.coordinates) {
			const options = {
				center: request.coordinates,
				zoom: request.zoom || 14,
				speed: 0.25
			};

			map.flyTo(options);
			return;
		}

		if (request.bounds) {
			const options = {
				padding: 60,
				duration: 1500,
				padding: request.padding || 0
			};

			// console.log("flying to ", request.bounds, options);
			map.fitBounds(request.bounds, options);

			return;
		}
	}

	function onMapLoaded() {
		console.log("map loaded and painted");

		if (onLoad) {
			onLoad(map);
		}
	}

	// setTimeout(() => {
	//     document.documentElement.style.height = `100%`;
	//     map.resize();
	//     setTimeout(() => {
	//         // this line prevents the content
	//         // from hiding behind the address bar
	//         window.scrollTo(0, 1);
	//     }, 500);
	// }, 500);
	onMount(async () => {
		// const response = await fetch('./mapstyle.json');
		// const esriMapStyle = await response.json();
		// const mapStyle = await adaptEsriMapStyle(esriMapStyle);
		const mapStyle = await getMapStyle();

		// SW, NE
		const maxBounds = [[5.4052734375, 45.838367585245855], [7.248229980468751, 46.66263249079177]];

		// mapboxgl.accessToken = 'ezree';
		$$invalidate(0, map = new maplibregl.Map({
				container, // container id
				style: mapStyle,
				interactive,
				pitch, // pitch in degrees
				center: startCoordinates || genevaCoords,
				zoom: startZoom, // starting zoom,
				minZoom: 9,
				maxZoom: 18,
				maxBounds,
				attributionControl: false
			}));

		if (useControls) {
			map.addControl(new maplibregl.NavigationControl());
		}

		mapEventProvider.initMap(map);
		flyToProvider.addListener(onFlyToRequest);
		map.on('load', onMapLoaded);

		// TODO: move this to a better place 
		window.addEventListener('orientationchange', hackIosRotationSnaffu);
	});

	onDestroy(() => {
		console.log("unmounting map--------------------------------------");
		window.removeEventListener('orientationchange', hackIosRotationSnaffu);
		map.off(onMapLoaded);

		// mapEventProvider.cleanup();
		flyToProvider.removeListener(onFlyToRequest);

		map.remove();
	});

	function div_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			container = $$value;
			$$invalidate(1, container);
		});
	}

	$$self.$$set = $$props => {
		if ('onLoad' in $$props) $$invalidate(2, onLoad = $$props.onLoad);
		if ('startCoordinates' in $$props) $$invalidate(3, startCoordinates = $$props.startCoordinates);
		if ('startZoom' in $$props) $$invalidate(4, startZoom = $$props.startZoom);
		if ('interactive' in $$props) $$invalidate(5, interactive = $$props.interactive);
		if ('pitch' in $$props) $$invalidate(6, pitch = $$props.pitch);
		if ('useControls' in $$props) $$invalidate(7, useControls = $$props.useControls);
		if ('$$scope' in $$props) $$invalidate(8, $$scope = $$props.$$scope);
	};

	return [
		map,
		container,
		onLoad,
		startCoordinates,
		startZoom,
		interactive,
		pitch,
		useControls,
		$$scope,
		slots,
		div_binding
	];
}

class MapLibre extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			onLoad: 2,
			startCoordinates: 3,
			startZoom: 4,
			interactive: 5,
			pitch: 6,
			useControls: 7
		});
	}
}

export default MapLibre;